import { useEffect } from "react";
import { Helmet } from "react-helmet";

import "../pages/Terms.css";
import Navbar from "../components/Navbar";
import Footer from "../components/Footer";

export default function Terms() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <>
      <Helmet>
        <title>Terms & Conditions | RAD EnviroNex | Service Agreements</title>
        <meta name="description" content="Review the terms and conditions for using RAD EnviroNex services, including solar installation, wastewater treatment, and environmental consultancy." />
        <meta name="keywords" content="Terms and Conditions RAD EnviroNex, Service Agreement Madurai, Environmental consultancy terms, solar project terms" />
        <link rel="canonical" href="https://radenvironex.com/Terms" />
      </Helmet>
      <Navbar />


      {/* TERMS & CONDITIONS */}
      <section id="terms-section">
        <div className="terms-wrapper" data-aos="fade-up">

          <h1>Terms & Conditions</h1>

          <p className="terms-intro">
            Welcome to <strong>RAD EnviroNex</strong>. By accessing our website
            or engaging with our services, you agree to comply with and be
            bound by the following Terms & Conditions. Please read them
            carefully before using our services.
          </p>

          <div className="terms-block" data-aos="slide-up">
            <h3>1. Scope of Services</h3>
            <p>
              RAD EnviroNex provides environmental engineering solutions
              including but not limited to Sewage Treatment Plants (STP),
              Effluent Treatment Plants (ETP), Biogas systems, Solar solutions,
              and related consultancy, design, installation, commissioning,
              and maintenance services.
            </p>
          </div>

          <div className="terms-block" data-aos="slide-up" data-aos-delay="100">
            <h3>2. Use of Website</h3>
            <ul>
              <li>The content on this website is for general information purposes only</li>
              <li>You may not misuse, reproduce, or distribute website content without written permission</li>
              <li>Unauthorized use may give rise to legal claims</li>
            </ul>
          </div>

          <div className="terms-block" data-aos="slide-up" data-aos-delay="200">
            <h3>3. Project Estimates & Proposals</h3>
            <p>
              All quotations, technical proposals, and timelines provided by
              RAD EnviroNex are indicative and subject to site conditions,
              approvals, statutory permissions, and final contractual
              agreements.
            </p>
          </div>

          <div className="terms-block" data-aos="slide-up" data-aos-delay="300">
            <h3>4. Payments & Commercial Terms</h3>
            <ul>
              <li>Payments shall be made as per agreed milestones or contract terms</li>
              <li>Delay in payment may result in suspension of work or services</li>
              <li>Taxes, duties, and statutory levies shall be borne by the client unless stated otherwise</li>
            </ul>
          </div>

          <div className="terms-block" data-aos="slide-up" data-aos-delay="400">
            <h3>5. Compliance & Client Responsibilities</h3>
            <ul>
              <li>Clients must provide accurate site data, effluent details, and operational inputs</li>
              <li>Statutory approvals (CTE, CTO, local permissions) are the responsibility of the client unless agreed otherwise</li>
              <li>RAD EnviroNex shall not be liable for delays due to third-party or regulatory approvals</li>
            </ul>
          </div>

          <div className="terms-block" data-aos="slide-up" data-aos-delay="500">
            <h3>6. Performance & Limitations</h3>
            <p>
              System performance is dependent on proper operation, maintenance,
              and adherence to recommended guidelines. RAD EnviroNex shall not
              be liable for performance issues arising from misuse, improper
              operation, or unauthorized modifications.
            </p>
          </div>

          <div className="terms-block" data-aos="slide-up" data-aos-delay="600">
            <h3>7. Intellectual Property</h3>
            <p>
              All designs, drawings, documents, and technical content provided
              by RAD EnviroNex remain the intellectual property of the company
              unless otherwise agreed in writing.
            </p>
          </div>

          <div className="terms-block" data-aos="slide-up" data-aos-delay="700">
            <h3>8. Limitation of Liability</h3>
            <p>
              RAD EnviroNex shall not be liable for indirect, incidental, or
              consequential damages arising out of the use of our website or
              services, to the maximum extent permitted by law.
            </p>
          </div>

          <div className="terms-block" data-aos="slide-up" data-aos-delay="800">
            <h3>9. Governing Law & Jurisdiction</h3>
            <p>
              These Terms & Conditions shall be governed by and construed in
              accordance with the laws of India. Any disputes shall be subject
              to the exclusive jurisdiction of Indian courts.
            </p>
          </div>

          <div className="terms-block" data-aos="slide-up" data-aos-delay="900">
            <h3>10. Changes to Terms</h3>
            <p>
              RAD EnviroNex reserves the right to update or modify these Terms &
              Conditions at any time. Continued use of our website or services
              constitutes acceptance of the revised terms.
            </p>
          </div>

        </div>
      </section>

      <Footer />
    </>
  );
}
